<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'financial-finDetail-reimbursement',
  components: { PageTable },
}
</script>
